<template>
	<div class="form-option-set" :class="{ inline: inline }">
		<ul v-if="!inline">
			<li v-for="{ value, label, description } in options" :key="value">
				<b-radio v-model="selected" :native-value="value">
					<p>
						{{ label }}
					</p>
					<p v-if="description" class="message">{{ description }}</p>
				</b-radio>
			</li>
		</ul>
		<div v-else class="control">
			<b-radio
				v-for="{ value, label } in options"
				:key="value"
				v-model="selected"
				:native-value="value"
			>
				{{ label }}
			</b-radio>
		</div>
	</div>
</template>

<script>
export default {
	name: "FieldOptionSet",
	props: {
		options: {
			type: Array,
			required: true
		},
		preSelect: {
			type: String,
			default: () => null
		},
		inline: {
			type: Boolean,
			default: () => false
		}
	},
	data() {
		return {
			selected: ""
		};
	},
	watch: {
		selected(data) {
			this.$emit("change", data);
		},
		preSelect(value) {
			this.selected = value;
		}
	},
	created() {
		if (this.preSelect) {
			this.selected = this.preSelect;
		}
	}
};
</script>

<style lang="scss">
.form-option-set {
	.b-radio.radio {
		align-items: start;
	}
	.message {
		font-size: 0.9rem;
		margin-bottom: 0.5rem;
	}
	li:not(:last-child) {
		margin-bottom: 0.5em;
	}
	&.inline {
		.b-radio.radio:not(:last-child) {
			margin-right: 1rem;
		}
	}
}
</style>
